import { Box, Grid } from "@mui/material";
import React, { useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./StudentDetails.scss";
import { styled } from "@mui/material/styles";
import green_icon from "../../../globals/assets/green_computer.svg";
import Switch from "@mui/material/Switch";
import Stack from "@mui/material/Stack";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";
import CardView from "../StudentCard";
import { useDispatch, useSelector } from "react-redux";
import { studentID, showStudentDetails } from "../../../redux/features/student";
import closeImg from "../../../Images/closed.png";

const StudentDetails = ({ res, ondeleteClick }) => {
  const navigate = useNavigate();
  const [selectedFile, setSelectedFile] = useState();
  const [uploadData, setUploadData] = useState([]);
  const [errorMessage, setErrorMessage] = useState([]);
  const [uploadFilterData, setuploadFilterData] = useState([]);
  console.log("res", res);
  const dispatch = useDispatch();

  let studentID = useSelector((state) => state.studentDetail.id);

  let detail = res?.filter((res) => {
    return res.id == studentID;
  });

  let title = detail[0]?.name;
  let titlelength = title?.length;
  let slicedTitle = title?.slice(0, 25);

  let trainingCenter = detail[0]?.[`studio.studio_name`];
  let trainingCenterLength = trainingCenter?.length;
  let slicedtrainingCenter = trainingCenter?.slice(0, 12);

  return (
    <>
      <div id="StudentDetails">
        <Box className="TrainingDetailsListMainContainer">
          <Grid container columnSpacing={2} spacing="1%">
            <Grid item xs={12} sm={12} md={8} lg={8}>
              <div className="detailsContainer">
                <Box className="childDetailsContainer">
                  <Box className="containerMargin">
                    <Grid container>
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        <Box className="fs-3">
                          Student Name -{" "}
                          {detail[0]?.name
                            ? titlelength > 25
                              ? `${slicedTitle}...`
                              : detail[0]?.name
                            : ""}
                          {/* {detail[0]?.name} */}
                        </Box>
                      </Grid>
                      <Grid item xs={11} sm={5} md={5} lg={5}>
                        <span className="TrainingDetailsUpcoming medium_f_bold">
                          Upcoming Training
                        </span>
                      </Grid>
                      <Grid item xs={1} sm={1} md={1} lg={1}>
                        <Stack justifyContent="flex-end" alignItems="flex-end">
                          <img
                            src={closeImg}
                            className="closeStudent"
                            onClick={() => {
                              // alert();
                              dispatch(showStudentDetails(false));
                              // console.log('name', res.id);
                            }}
                          />
                        </Stack>
                      </Grid>
                    </Grid>
                  </Box>
                  <Box className="containerMargin marginTop">
                    <Grid container columnSpacing={4}>
                      <Grid item xs={12} sm={6} md={6} lg={4}>
                        <Box className="medium_f training_details_page_instructor_name">
                          Training Center -
                          <span className="medium_f_bold">
                            {trainingCenterLength > 18
                              ? `${slicedtrainingCenter}...`
                              : detail[0]?.[`studio.studio_name`]}
                          </span>
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} lg={4}>
                        <Box className="medium_f training_details_page_instructor_name">
                          Contact no -
                          <span className="medium_f_bold">
                            {detail[0]?.[`studio.contact_no`]}
                          </span>
                        </Box>
                      </Grid>
                      {/* <Grid item xs={0} sm={0} md={6} lg={4}>
												<Box className="medium_f">
													Email ID -
													<span className="medium_f_bold">
														{detail[0]?.[`studio.email`]}
													</span>
												</Box>
											</Grid> */}
                    </Grid>
                  </Box>
                  <Box className="containerMargin marginTop">
                    <Grid container columnSpacing={4}>
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        <Box className="medium_f training_details_page_instructor_name">
                          Time Zone -
                          <span className="medium_f_bold">
                            (UTC + 05:30) Chennai, Kolkata, Mumbai
                          </span>
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        <Box className="medium_f">
                          Skills -
                          <span className="medium_f_bold">
                            Communication, Gaming
                          </span>
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                  <Box className="containerMargin marginTop">
                    <Grid container columnSpacing={4}>
                      <Grid item xs={10.5} sm={10.5} md={10.5} lg={10.5}>
                        <Box className="small_f">
                          {detail[0]?.short_information}
                        </Box>
                      </Grid>
                      {/* <Grid item xs={12} sm={1.5} md={1.5} lg={1.5}>
												<Box className="trainingDetailsstartIn">
													<Grid
														container
														direction="row"
														justifyContent="center"
														alignContent="center"
													>
														<Grid xs={12} className="small_f">
															start in
														</Grid>
														<Grid xs={12} className="larger_f_bold">
															7
														</Grid>

														<Grid xs={12} className="small_f">
															Days
														</Grid>
													</Grid>
													<Box></Box>
													<Box></Box>
													<Box></Box>
												</Box>
											</Grid> */}
                    </Grid>
                  </Box>
                  <Box className="containerMargin marginTop">
                    <Grid container spacing={1}>
                      <Grid item xs={12} sm={12} md={6} lg={6}>
                        <Box className="startEndTrainingDetails">
                          <Stack direction="row" justifyContent="space-between">
                            <Stack className="fs-4">
                              Average Session Length :
                            </Stack>
                            <Stack className="fs-6">
                              {detail[0]?.avg_session_length}hrs
                            </Stack>
                          </Stack>
                        </Box>
                      </Grid>
                      {/* <Grid item xs={12} sm={12} md={6} lg={6}>
												<Box className="startEndTrainingDetails">
													<Stack direction="row" justifyContent="space-between">
														<Stack className="fs-4">Total Students :</Stack>
														<Stack className="fs-6">20</Stack>
													</Stack>
												</Box>
											</Grid> */}
                      <Grid item xs={12} sm={12} md={6} lg={6}>
                        <Box className="startEndTrainingDetails">
                          <Stack direction="row" justifyContent="space-between">
                            <Stack className="fs-4">
                              Total Scheduled Training :
                            </Stack>
                            <Stack className="fs-6">
                              {detail[0]?.training_count}
                            </Stack>
                          </Stack>
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                  <Box className="containerMargin">
                    <Grid container spacing={1}>
                      <Grid item xs={12} sm={12} md={6} lg={6}>
                        <Box className="startEndTrainingDetails">
                          <Stack direction="row" justifyContent="space-between">
                            <Stack className="fs-4">
                              Average no. of Disconnect :
                            </Stack>
                            <Stack className="fs-6">
                              {detail[0]?.training_disconnect}
                            </Stack>
                          </Stack>
                        </Box>
                      </Grid>
                      {/* <Grid item xs={12} sm={12} md={6} lg={6}>
												<Box className="startEndTrainingDetails">
													<Stack direction="row" justifyContent="space-between">
														<Stack className="fs-4">
															Total Scheduled Training :
														</Stack>
														<Stack className="fs-6">
															{detail[0]?.training_count}
														</Stack>
													</Stack>
												</Box>
											</Grid> */}
                    </Grid>
                  </Box>

                  {/* <input
                    type="file"
                    // value="Browse"
                    name="browser"
                    className="TrainingDetialsbrowseButton"
                    // onClick={openfile}
                    onChange={onFileChange}
                    // for="file-upload"
                    // id="file-drag"
                  /> */}
                </Box>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4}>
              <Box className="detailsContainer">
                <Grid container columnSpacing={4}>
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <Stack direction="row" flexWrap="wrap">
                      <CardView
                        res={res}
                        lgWidth={12}
                        ondeleteClick={ondeleteClick}
                      />
                    </Stack>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </div>
    </>
  );
};

export default StudentDetails;
